// extracted by mini-css-extract-plugin
export default {"container":"NotAuthorized_container__d1-tt"};